import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-multiple-fields',
  templateUrl: './multiple-fields.component.html',
  styleUrls: ['./multiple-fields.component.scss']
})
export class MultipleFieldsComponent implements OnInit {
  @Input() fields: string[] = [];
  @Input() placeholder: string;
  @Output() fieldsChange = new EventEmitter<string[]>();

  constructor() { }

  ngOnInit() {
  }

  addNewEmptyField() {
    this.fields.push('');
  }

  changeField(index: number, value: string) {
    this.fields[index] = value;
  }

  trackByIndex(index: number, value: number) {
    return index;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/multiple-fields/multiple-fields.component.ts